'use client';

/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

import cx from 'classnames';
import React, {
  FC, useState, useCallback, KeyboardEvent, useRef,
} from 'react';

import useOnClickOutside from '@/hooks/use-on-click-outside';

import Shevron from './assets/icon-shevron-grey.svg';

import styles from './part-select.module.scss';

interface IPartSelectProps {
  options: string[] | undefined;
  getSelectData: (chosenOption: string) => void;
  defaultListValue: string;
}

const PartSelect: FC<IPartSelectProps> = ({ options, getSelectData, defaultListValue }) => {
  const [current, setCurrent] = useState(defaultListValue);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const selectContainerRef = useRef(null);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prevState) => !prevState);
  }, []);

  const handlerClosedSelect = useCallback(
    () => {
      setIsMenuOpen(false);
    },
    [],
  );

  const handleSelectInteraction = useCallback(
    (chosenOption: string): void => {
      setCurrent(chosenOption);
      getSelectData(chosenOption);
      toggleMenu();
    },
    [toggleMenu],
  );

  const handleMenuKeyDown = useCallback(
    (event: KeyboardEvent<HTMLDivElement>): void => {
      if (event.key === 'Enter') {
        toggleMenu();
      }
    },
    [toggleMenu],
  );

  const handleOptionKeyDown = useCallback(
    (event: KeyboardEvent<HTMLLIElement>, chosenOption: string): void => {
      if (event.key === 'Enter') {
        handleSelectInteraction(chosenOption);
      }
    },
    [handleSelectInteraction],
  );

  useOnClickOutside(selectContainerRef, handlerClosedSelect);

  return (
    <div className={styles.container} ref={selectContainerRef}>
      <div
        className={styles.currentContainer}
        onClick={toggleMenu}
        onKeyDown={handleMenuKeyDown}
        role="button"
        tabIndex={0}
      >
        <p className={styles.current}>{current}</p>
        <div className={styles.shevronContainer}>
          <Shevron
            className={cx(styles.shevron, {
              [styles.shevronUp]: isMenuOpen,
            })}
          />
        </div>
      </div>
      {isMenuOpen && (
        <ul className={styles.optionsContainer}>
          {options && options.map((option) => (
            <li
              key={option}
              className={styles.option}
              onClick={() => handleSelectInteraction(option)}
              onKeyDown={(event) => handleOptionKeyDown(event, option)}
              role="button"
              tabIndex={0}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PartSelect;
